import { createContext } from 'react';

export const sourceContext = createContext({
  videosSource: '',
  setVideosSource: () => {}
});
